import { Loader2 } from 'lucide-react';

export const FullScreenLoader = ({ label = 'Loading…' }) => (
  <div className="app-canvas flex min-h-screen items-center justify-center">
    <div className="flex flex-col items-center gap-3 text-foreground/70">
      <Loader2 className="h-7 w-7 animate-spin text-brand-cyan" />
      <span className="text-sm">{label}</span>
    </div>
  </div>
);
